import React from "react"

export const containerStyle: React.CSSProperties = {
	display: "flex",
	flexDirection: "column",
	height: "100%",
	width: "100%",
}

export const statsContainerStyle: React.CSSProperties = {
	display: "flex",
	gap: 10,
	paddingBottom: "14px",
	flexWrap: "wrap",
	backgroundColor: "transparent",
}

export const statCardStyle: React.CSSProperties = {
	flex: "1 1 150px",
	minWidth: 150,
	backgroundColor: "white",
	borderRadius: 8,
	padding: "20px 24px",
	boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
	display: "flex",
	flexDirection: "column",
	gap: 10,
	position: "relative",
	overflow: "hidden",
}

export const statIconContainerStyle = (color: string): React.CSSProperties => ({
	width: 34,
	height: 34,
	borderRadius: 8,
	backgroundColor: color,
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	flexShrink: 0,
})

export const statLabelStyle: React.CSSProperties = {
	fontSize: 12,
	fontWeight: 500,
	color: "#8e9aab",
}

export const statValueStyle: React.CSSProperties = {
	fontSize: 22,
	fontWeight: 700,
	color: "#103246",
	lineHeight: 1,
}

export const mapContainerStyle: React.CSSProperties = {
	flex: 1,
	position: "relative",
	minHeight: 400,
}

export const loadingOverlayStyle: React.CSSProperties = {
	position: "absolute",
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	backgroundColor: "rgba(255, 255, 255, 0.8)",
	zIndex: 10,
}

export const errorContainerStyle: React.CSSProperties = {
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	backgroundColor: "#f5f5f5",
	color: "#ff4d4f",
	height: "100%",
}

export const emptyStateStyle: React.CSSProperties = {
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	height: "100%",
	color: "#888",
	gap: 8,
}

export const vehiclePanelStyle: React.CSSProperties = {
	position: "absolute",
	top: 10,
	left: 10,
	zIndex: 100,
	backgroundColor: "white",
	borderRadius: 8,
	boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
	padding: "12px 16px",
	minWidth: 220,
	maxWidth: 280,
}

export const vehiclePanelHeaderStyle: React.CSSProperties = {
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	marginBottom: 8,
}

export const vehiclePanelCloseStyle: React.CSSProperties = {
	cursor: "pointer",
	padding: 4,
	lineHeight: 1,
	borderRadius: 4,
}

export const vehicleInfoRowStyle: React.CSSProperties = {
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	fontSize: 13,
	padding: "4px 0",
}

export const controlsContainerStyle: React.CSSProperties = {
	position: "absolute",
	top: 55,
	right: 10,
	zIndex: 100,
	display: "flex",
	flexDirection: "column",
	gap: 4,
}

export const buttonStyle: React.CSSProperties = {
	height: 32,
	padding: "0 12px",
	display: "flex",
	alignItems: "center",
	gap: 6,
	backgroundColor: "white",
	border: "none",
	borderRadius: 4,
	boxShadow: "0 1px 4px rgba(0, 0, 0, 0.2)",
	cursor: "pointer",
	fontSize: 13,
	color: "rgba(0, 0, 0, 0.87)",
}

export const legendContainerStyle: React.CSSProperties = {
	position: "absolute",
	bottom: 10,
	left: 10,
	zIndex: 100,
	display: "flex",
	flexDirection: "column",
	gap: 6,
	padding: "10px 14px",
	backgroundColor: "white",
	borderRadius: 8,
	boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
	fontSize: 12,
	color: "rgba(0, 0, 0, 0.65)",
	maxWidth: 340,
}

export const legendItemStyle: React.CSSProperties = {
	display: "flex",
	alignItems: "center",
	gap: 6,
}

export const legendSectionTitleStyle: React.CSSProperties = {
	fontWeight: 600,
	fontSize: 11,
	color: "rgba(0, 0, 0, 0.45)",
	textTransform: "uppercase",
	letterSpacing: 0.5,
}

export const mapStyles = {
	hidePOIs: [
		{
			featureType: "poi",
			elementType: "all",
			stylers: [{ visibility: "off" }],
		},
		{
			featureType: "transit",
			elementType: "all",
			stylers: [{ visibility: "off" }],
		},
	],
}
